// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".table-header[data-v-50773781]{text-transform:uppercase;text-align:left;background:#00a0dc;color:#fff;padding:10px;font:14px/14px pt_sansregular}.subelement-headers[data-v-50773781]{margin-top:25px}.center-service-button[data-v-50773781]{display:flex;justify-content:center;align-items:center;height:100%}.add-margin[data-v-50773781]{margin-top:2rem;height:70px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
